import { useEffect } from 'react';
import { init } from '@plausible-analytics/tracker';

const PlausibleAnalytics = () => {
  useEffect(() => {
    if (
      window.runConfig?.nodeEnv !== 'prod' ||
      !window.runConfig?.plausibleDomain ||
      !window.runConfig?.plausibleApiHost
    ) {
      return;
    }

    init({
      domain: window.runConfig.plausibleDomain,
      endpoint: window.runConfig.plausibleApiHost,
    });
  }, []);

  return null;
};

export default PlausibleAnalytics;
